import React, { useEffect, useState } from 'react';
import { BasicCards } from '../components/BasicCards';
import { HandRankings } from '../components/HandRankings';
import { ScoringSystem } from '../components/ScoringSystem';
import { InteractiveHandBuilder } from '../components/InteractiveHandBuilder';
import { JokerSection } from '../components/JokerSection';
type Section = 'intro' | 'basics' | 'hands' | 'scoring' | 'practice' | 'jokers';
interface NavItem {
  id: Section;
  label: string;
  emoji: string;
  sublabel: string;
}
const navItems: NavItem[] = [{
  id: 'intro',
  label: '游戏介绍',
  emoji: '🎮',
  sublabel: 'What is Balatro'
}, {
  id: 'basics',
  label: '认识扑克牌',
  emoji: '🃏',
  sublabel: 'Cards & Suits'
}, {
  id: 'hands',
  label: '牌型大全',
  emoji: '🏆',
  sublabel: 'Hand Rankings'
}, {
  id: 'scoring',
  label: '计分系统',
  emoji: '💯',
  sublabel: 'Scoring System'
}, {
  id: 'practice',
  label: '互动练习',
  emoji: '🎯',
  sublabel: 'Practice'
}, {
  id: 'jokers',
  label: '小丑牌',
  emoji: '🤡',
  sublabel: 'Joker Cards'
}];
export function BalatraGuide() {
  const [activeSection, setActiveSection] = useState<Section>('intro');
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navigateTo = (section: Section) => {
    setActiveSection(section);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen w-full stars-bg" style={{
    background: 'var(--bg-deep)'
  }} data-id="element-347">
      {/* Hero Header */}
      <div className="relative overflow-hidden" style={{
      background: 'linear-gradient(180deg, #0d0618 0%, #1a0a2e 60%, #0d0618 100%)',
      borderBottom: '1px solid rgba(255,215,0,0.2)',
      paddingBottom: activeSection === 'intro' ? 0 : undefined
    }} data-id="element-348">
        {/* Decorative glow */}
        <div style={{
        position: 'absolute',
        top: -100,
        left: '50%',
        transform: 'translateX(-50%)',
        width: 600,
        height: 300,
        background: 'radial-gradient(ellipse, rgba(180,79,255,0.15) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} data-id="element-349" />

        <div className="max-w-5xl mx-auto px-4 pt-10 pb-6 text-center relative" data-id="element-350">
          <div className="text-6xl mb-3 animate-float" data-id="element-351">🃏</div>
          <h1 className="text-4xl md:text-6xl font-black mb-2 glow-gold" style={{
          color: '#FFD700',
          fontFamily: 'Cinzel, serif',
          letterSpacing: '0.05em'
        }} data-id="element-352">
            BALATRO
          </h1>
          <h2 className="text-xl md:text-2xl font-bold mb-1" style={{
          color: '#b44fff',
          fontFamily: 'Cinzel, serif'
        }} data-id="element-353">
            小丑牌
          </h2>
          <p className="text-sm" style={{
          color: '#9080b0'
        }} data-id="element-354">
            完全新手入门指南 · Complete Beginner's Guide
          </p>
        </div>

        {/* Navigation */}
        <nav className="sticky top-0 z-50 transition-all duration-300" style={{
        background: isScrolled ? 'rgba(13,6,24,0.95)' : 'rgba(13,6,24,0.7)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,215,0,0.15)',
        boxShadow: isScrolled ? '0 4px 20px rgba(0,0,0,0.5)' : 'none'
      }} data-id="element-355">
          <div className="max-w-5xl mx-auto px-4 py-2" data-id="element-356">
            <div className="flex gap-1 overflow-x-auto pb-1" style={{
            scrollbarWidth: 'none'
          }} data-id="element-357">
              {navItems.map(item => <button key={item.id} onClick={() => navigateTo(item.id)} className={`nav-tab flex-shrink-0 flex items-center gap-1.5 ${activeSection === item.id ? 'active' : ''}`} data-id="element-358">
                  <span data-id="element-359">{item.emoji}</span>
                  <span className="hidden sm:inline" data-id="element-360">{item.label}</span>
                  <span className="sm:hidden text-xs" data-id="element-361">
                    {item.label.slice(0, 4)}
                  </span>
                </button>)}
            </div>
          </div>
        </nav>
      </div>

      {/* Main content */}
      <main className="max-w-5xl mx-auto px-4 py-8" data-id="element-362">
        {/* Intro Section */}
        {activeSection === 'intro' && <div className="space-y-8" data-id="element-363">
            <div className="panel p-8 text-center" data-id="element-364">
              <h2 className="text-3xl font-bold mb-4 glow-gold" style={{
            color: '#FFD700',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-365">
                欢迎来到小丑牌的世界！
              </h2>
              <p className="text-lg mb-6" style={{
            color: '#c0a0e0'
          }} data-id="element-366">
                小丑牌（Balatro）是一款以扑克牌为基础的
                <span style={{
              color: '#FFD700'
            }} data-id="element-367">
                  肉鸽（Roguelike）
                </span>
                游戏。 你不需要有任何扑克牌基础，这个指南会从零开始教你！
              </p>
              <div className="flex justify-center gap-4 flex-wrap" data-id="element-368">
                <div className="chip-badge px-4 py-2 rounded-xl text-sm" data-id="element-369">
                  🎮 单人游戏
                </div>
                <div className="mult-badge px-4 py-2 rounded-xl text-sm" data-id="element-370">
                  🃏 扑克牌机制
                </div>
                <div className="score-badge px-4 py-2 rounded-xl text-sm" data-id="element-371">
                  🏆 策略性强
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-372">
              <div className="panel p-6" data-id="element-373">
                <h3 className="text-lg font-bold mb-4" style={{
              color: '#FFD700',
              fontFamily: 'Cinzel, serif'
            }} data-id="element-374">
                  🎯 游戏目标
                </h3>
                <div className="space-y-3" data-id="element-375">
                  <div className="flex items-start gap-3" data-id="element-376">
                    <span className="text-2xl flex-shrink-0" data-id="element-377">1️⃣</span>
                    <div data-id="element-378">
                      <div className="font-bold text-sm mb-1" style={{
                    color: '#e8d5ff'
                  }} data-id="element-379">
                        出牌得分
                      </div>
                      <p className="text-xs" style={{
                    color: '#9080b0'
                  }} data-id="element-380">
                        从手牌中选择最多5张牌打出，系统自动识别牌型并计算得分
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-381">
                    <span className="text-2xl flex-shrink-0" data-id="element-382">2️⃣</span>
                    <div data-id="element-383">
                      <div className="font-bold text-sm mb-1" style={{
                    color: '#e8d5ff'
                  }} data-id="element-384">
                        超过盲注
                      </div>
                      <p className="text-xs" style={{
                    color: '#9080b0'
                  }} data-id="element-385">
                        每一关都有目标分数（盲注），在规定出牌次数内达到即可过关
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-386">
                    <span className="text-2xl flex-shrink-0" data-id="element-387">3️⃣</span>
                    <div data-id="element-388">
                      <div className="font-bold text-sm mb-1" style={{
                    color: '#e8d5ff'
                  }} data-id="element-389">
                        强化牌组
                      </div>
                      <p className="text-xs" style={{
                    color: '#9080b0'
                  }} data-id="element-390">
                        过关后购买小丑牌和增强道具，让你的牌组越来越强
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-391">
                    <span className="text-2xl flex-shrink-0" data-id="element-392">4️⃣</span>
                    <div data-id="element-393">
                      <div className="font-bold text-sm mb-1" style={{
                    color: '#e8d5ff'
                  }} data-id="element-394">
                        通关8个小盲
                      </div>
                      <p className="text-xs" style={{
                    color: '#9080b0'
                  }} data-id="element-395">
                        完成所有关卡就算通关！每次游戏都是全新的体验
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="panel p-6" data-id="element-396">
                <h3 className="text-lg font-bold mb-4" style={{
              color: '#FFD700',
              fontFamily: 'Cinzel, serif'
            }} data-id="element-397">
                  🗺️ 游戏流程
                </h3>
                <div className="space-y-2" data-id="element-398">
                  {[{
                step: '出牌阶段',
                desc: '选牌→打出→得分，重复直到达到目标',
                color: '#4fc3f7'
              }, {
                step: '商店阶段',
                desc: '用金币购买小丑牌、增强牌等道具',
                color: '#FFD700'
              }, {
                step: '下一关',
                desc: '盲注分数越来越高，挑战越来越大',
                color: '#ff6666'
              }, {
                step: 'Boss关卡',
                desc: '每组第三关有特殊负面效果的Boss盲注',
                color: '#b44fff'
              }].map(item => <div key={item.step} className="flex items-center gap-3 p-2 rounded-lg" style={{
                background: 'rgba(0,0,0,0.3)'
              }} data-id="element-399">
                      <div className="w-2 h-2 rounded-full flex-shrink-0" style={{
                  background: item.color,
                  boxShadow: `0 0 6px ${item.color}`
                }} data-id="element-400" />
                      <div data-id="element-401">
                        <span className="text-sm font-bold" style={{
                    color: item.color
                  }} data-id="element-402">
                          {item.step}
                        </span>
                        <span className="text-xs ml-2" style={{
                    color: '#9080b0'
                  }} data-id="element-403">
                          {item.desc}
                        </span>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>

            {/* Key concepts */}
            <div className="panel p-6" data-id="element-404">
              <h3 className="text-lg font-bold mb-4" style={{
            color: '#FFD700',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-405">
                🔑 三个核心概念
              </h3>
              <div className="grid md:grid-cols-3 gap-4" data-id="element-406">
                <div className="p-4 rounded-xl text-center" style={{
              background: 'rgba(79,195,247,0.1)',
              border: '1px solid rgba(79,195,247,0.3)'
            }} data-id="element-407">
                  <div className="chip-badge px-4 py-2 rounded-xl text-xl number-mono mb-3 inline-block" data-id="element-408">
                    Chips
                  </div>
                  <div className="font-bold mb-2" style={{
                color: '#4fc3f7',
                fontFamily: 'Cinzel, serif'
              }} data-id="element-409">
                    筹码
                  </div>
                  <p className="text-xs" style={{
                color: '#b090d0'
              }} data-id="element-410">
                    来自牌型基础值和打出牌的点数。筹码越多，最终得分的基数越大。
                  </p>
                </div>
                <div className="p-4 rounded-xl text-center" style={{
              background: 'rgba(255,68,68,0.1)',
              border: '1px solid rgba(255,68,68,0.3)'
            }} data-id="element-411">
                  <div className="mult-badge px-4 py-2 rounded-xl text-xl number-mono mb-3 inline-block" data-id="element-412">
                    Mult
                  </div>
                  <div className="font-bold mb-2" style={{
                color: '#ff6666',
                fontFamily: 'Cinzel, serif'
              }} data-id="element-413">
                    倍率
                  </div>
                  <p className="text-xs" style={{
                color: '#b090d0'
              }} data-id="element-414">
                    来自牌型基础倍率和小丑牌加成。倍率越高，得分乘以的系数越大。
                  </p>
                </div>
                <div className="p-4 rounded-xl text-center" style={{
              background: 'rgba(180,79,255,0.1)',
              border: '1px solid rgba(180,79,255,0.3)'
            }} data-id="element-415">
                  <div className="joker-card px-4 py-2 rounded-xl text-xl mb-3 inline-block" style={{
                border: '1px solid rgba(180,79,255,0.5)'
              }} data-id="element-416">
                    <span style={{
                  color: '#b44fff'
                }} data-id="element-417">
                      Joker
                    </span>
                  </div>
                  <div className="font-bold mb-2" style={{
                color: '#b44fff',
                fontFamily: 'Cinzel, serif'
              }} data-id="element-418">
                    小丑牌
                  </div>
                  <p className="text-xs" style={{
                color: '#b090d0'
              }} data-id="element-419">
                    特殊增益卡，是游戏的灵魂！能大幅提升筹码、倍率，甚至改变游戏规则。
                  </p>
                </div>
              </div>
              <div className="mt-4 p-3 rounded-lg text-center" style={{
            background: 'rgba(255,215,0,0.05)',
            border: '1px solid rgba(255,215,0,0.2)'
          }} data-id="element-420">
                <span className="text-sm font-bold number-mono" style={{
              color: '#FFD700'
            }} data-id="element-421">
                  最终得分 = 筹码（Chips）× 倍率（Mult）
                </span>
              </div>
            </div>

            {/* Navigation cards */}
            <div data-id="element-422">
              <h3 className="text-lg font-bold mb-4" style={{
            color: '#FFD700',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-423">
                📚 开始学习
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-424">
                {navItems.slice(1).map(item => <button key={item.id} onClick={() => navigateTo(item.id)} className="panel p-4 text-left transition-all duration-200 hover:scale-105" style={{
              cursor: 'pointer'
            }} data-id="element-425">
                    <div className="text-2xl mb-2" data-id="element-426">{item.emoji}</div>
                    <div className="font-bold text-sm mb-1" style={{
                color: '#FFD700',
                fontFamily: 'Cinzel, serif'
              }} data-id="element-427">
                      {item.label}
                    </div>
                    <div className="text-xs" style={{
                color: '#7060a0'
              }} data-id="element-428">
                      {item.sublabel}
                    </div>
                  </button>)}
              </div>
            </div>
          </div>}

        {/* Basics Section */}
        {activeSection === 'basics' && <div data-id="element-429">
            <div className="mb-6" data-id="element-430">
              <h2 className="text-2xl font-bold mb-2 glow-gold" style={{
            color: '#FFD700',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-431">
                🃏 认识扑克牌
              </h2>
              <p className="text-sm" style={{
            color: '#9080b0'
          }} data-id="element-432">
                从零开始！先了解扑克牌的基础知识，这是理解小丑牌的第一步。
              </p>
            </div>
            <BasicCards data-id="element-433" />
          </div>}

        {/* Hand Rankings Section */}
        {activeSection === 'hands' && <div data-id="element-434">
            <div className="mb-6" data-id="element-435">
              <h2 className="text-2xl font-bold mb-2 glow-gold" style={{
            color: '#FFD700',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-436">
                🏆 牌型大全
              </h2>
              <p className="text-sm" style={{
            color: '#9080b0'
          }} data-id="element-437">
                小丑牌中共有13种牌型，从最弱的高牌到最强的同花五条。每种牌型都有固定的基础筹码和倍率。
              </p>
            </div>
            <HandRankings data-id="element-438" />
          </div>}

        {/* Scoring Section */}
        {activeSection === 'scoring' && <div data-id="element-439">
            <div className="mb-6" data-id="element-440">
              <h2 className="text-2xl font-bold mb-2 glow-gold" style={{
            color: '#FFD700',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-441">
                💯 计分系统
              </h2>
              <p className="text-sm" style={{
            color: '#9080b0'
          }} data-id="element-442">
                理解计分系统是掌握小丑牌策略的关键。筹码 × 倍率 =
                得分，听起来简单，但配合小丑牌后变化无穷！
              </p>
            </div>
            <ScoringSystem data-id="element-443" />
          </div>}

        {/* Practice Section */}
        {activeSection === 'practice' && <div data-id="element-444">
            <div className="mb-6" data-id="element-445">
              <h2 className="text-2xl font-bold mb-2 glow-gold" style={{
            color: '#FFD700',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-446">
                🎯 互动练习台
              </h2>
              <p className="text-sm" style={{
            color: '#9080b0'
          }} data-id="element-447">
                动手试试！从52张牌中选择最多5张，系统会自动识别你的牌型并计算得分。
              </p>
            </div>
            <InteractiveHandBuilder data-id="element-448" />
          </div>}

        {/* Jokers Section */}
        {activeSection === 'jokers' && <div data-id="element-449">
            <div className="mb-6" data-id="element-450">
              <h2 className="text-2xl font-bold mb-2" style={{
            color: '#b44fff',
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 20px rgba(180,79,255,0.5)'
          }} data-id="element-451">
                🤡 小丑牌详解
              </h2>
              <p className="text-sm" style={{
            color: '#9080b0'
          }} data-id="element-452">
                小丑牌是游戏的灵魂！了解不同类型的小丑牌，学会组合搭配，打出天文数字的得分！
              </p>
            </div>
            <JokerSection data-id="element-453" />
          </div>}

        {/* Bottom navigation */}
        <div className="mt-12 section-divider" data-id="element-454" />
        <div className="flex justify-between items-center mt-6 flex-wrap gap-3" data-id="element-455">
          {navItems.findIndex(n => n.id === activeSection) > 0 && <button onClick={() => {
          const idx = navItems.findIndex(n => n.id === activeSection);
          navigateTo(navItems[idx - 1].id);
        }} className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all duration-200" style={{
          background: 'rgba(255,215,0,0.08)',
          border: '1px solid rgba(255,215,0,0.25)',
          color: '#c0a040',
          cursor: 'pointer'
        }} data-id="element-456">
              ←{' '}
              {navItems[navItems.findIndex(n => n.id === activeSection) - 1]?.label}
            </button>}
          <div className="flex-1" data-id="element-457" />
          {navItems.findIndex(n => n.id === activeSection) < navItems.length - 1 && <button onClick={() => {
          const idx = navItems.findIndex(n => n.id === activeSection);
          navigateTo(navItems[idx + 1].id);
        }} className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold transition-all duration-200" style={{
          background: 'rgba(255,215,0,0.15)',
          border: '1px solid rgba(255,215,0,0.4)',
          color: '#FFD700',
          cursor: 'pointer',
          boxShadow: '0 0 10px rgba(255,215,0,0.2)'
        }} data-id="element-458">
              {navItems[navItems.findIndex(n => n.id === activeSection) + 1]?.label}{' '}
              →
            </button>}
        </div>

        {/* Footer */}
        <div className="mt-8 text-center pb-8" data-id="element-459">
          <p className="text-xs" style={{
          color: '#4a3060'
        }} data-id="element-460">
            小丑牌新手指南 · Balatro Beginner's Guide · 非官方教程
          </p>
        </div>
      </main>
    </div>;
}